import { LI, UL } from "../../../../../AbstractElements";

const DotText = () => {
  return (
    <UL className="dot-group pb-3 pt-0 simple-list">
      <LI />
      <LI />
      <LI />
    </UL>
  );
};

export default DotText;
